import { MetaData } from "@qid/core";

export class FaceId extends MetaData {
  account_id: string;
  imageUrl: string;
  isLinked: boolean;
}
